import styled from "styled-components";
import { FormLabel, FormDataComp } from "./Modals/AddMeeting";

const FileContainer = styled.div`
  margin: 4px 0;

  > * + * {
    margin-top: 4px;
  }
`;

const ImagePreview = styled.img`
  display: block;
  max-width: 200px;
  max-height: 150px;
  border-radius: 4px;
  border: 1px solid #e5e7eb;
  object-fit: cover;
`;

const StatusText = styled.p`
  font-size: 0.75rem;
  color:#747171 ;
  margin: 0;
`;

export const ImageFieldWithPreview = ({ imageUrl, onChange }) => {
  return (
    <FormLabel>
      Image:

      <FileContainer>
        {imageUrl && (
          <ImagePreview
            src={imageUrl}
            alt="Current image preview"
          />
        )}

        <FormDataComp
          type={"file"}
          accept="image/*"
          name="image"
          onChange={onChange}
        />

        <StatusText className="mt-2 text-sm text-red-400">
          {imageUrl
            ? "Upload a new image to replace the existing one" 
            : "No image previously uploaded"
          }
        </StatusText>
      </FileContainer>
    </FormLabel>
  );
};